<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center">添加银行卡</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <el-form-item label="" prop="bank_name">
          <el-select class="block height-50" v-model="form.bank_name" placeholder="选择银行">
            <el-option
              v-for="bank in BANKLIST"
              :key="bank.value"
              :label="bank.label"
              :value="bank.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="name">
          <YueDanIpt model="name" :object="form" placeholder="持卡人" :focus="true"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="card_number">
          <YueDanIpt model="card_number" :object="form" placeholder="银行卡号"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import YueDanIpt from '../../../components/YueDanIpt'
import { BANKLIST } from '../../../services/constant.js'


export default {
  name: 'AddAddress',
  props: ['item'],
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    return {
      BANKLIST: BANKLIST,
      dialogFormVisible: false,
      loading: false,
      errors: null,
      isEmptyErrors: true,
      form: {
        name: '',
        card_number: ''
      },
      rules: {
        bank_name: [
          { required: true, message: '银行是必选项', trigger: 'change' }
        ],
        name: [
          { required: true, message: '持卡人是必填项', trigger: 'blur' }
        ],
        card_number: [
          { required: true, message: '账号是必填项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.form = {
        name: '',
        card_number: ''
      }
      this.isEmptyErrors = true
    },
    show () {
      this.dialogFormVisible = true
      setTimeout(() => {
        this.form.withdraw_type_id = this.item.id
      })
      Object.assign(this.form, this.item)
    },
    submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          let res = await api.post(this, {
            path: 'single.php',
            api: this.form.id ? 'update_withdraw_type': 'add_withdraw_type',
            data: this.form,
            loading: 'loading'
          })
          if (res.body.status == 'ok') {
            this.$emit('success')
            this.init()
            this.dialogFormVisible = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/components/AddBankCard.vue